import { TaxApiError } from "./errors";

export function exactRecord<T extends { id: string }>(
  items: readonly T[],
  id: string,
): T | undefined {
  return items.find((item) => item.id === id);
}

/** The list row is the full published record / immutable event. */
export function recordNotFound(what: string): TaxApiError {
  return new TaxApiError({
    code: "NOT_FOUND",
    status: 404,
    message: `${what} was not found`,
    retryable: false,
  });
}
